module.exports = __webpack_public_path__ + "static/media/growth.e9834234.png";